export enum StateRegistrationCitizenship {
  OpenLegis = '01',
  ToDPR = '02',
  ChoiceItalian = '03',
  ForeignCitizenship = '04',
  OpeLegis = '05',
  ForeignNaturalization = '06',
  RenunciationCitizenship = '07',
  DoubleCitizenship = '09',
  ItalianCitizenshipDP = '10',
}
